import { render, staticRenderFns } from "./WorkshopCapacityReport.vue?vue&type=template&id=d2c0cad2&scoped=true"
import script from "./WorkshopCapacityReport.vue?vue&type=script&lang=js"
export * from "./WorkshopCapacityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c0cad2",
  null
  
)

export default component.exports